import { getAppConfig } from "services/configService";
import { GET } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().ProductApiUrl;
};

export const getProduct = (requestInfo, productContentId) => {
  return GET(
    requestInfo,
    apiUrl() + `/v1/Products/${productContentId}?extendResponseCommand=none&extendResponseWithUrls=false`
  );
};
